import React from 'react'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaCode } from 'react-icons/fa'
import { IoSchool } from "react-icons/io5";
import { MdDesignServices, MdOutlineClass } from 'react-icons/md';
import { Flex, Tag } from '@chakra-ui/react'

export default function TimeLine({isDark}) {
  return (
    <div>
    <VerticalTimeline
        lineColor={ isDark ? '#c79292' : '#c79292'}
        >
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'transparent', border: '2px solid  #c79292'}}
              date="Aug 2022 - present"
              iconStyle={{ background: '#c79292', color: '#fff' }}
              icon={<MdDesignServices />}
            >
              <h3 className="vertical-timeline-element-title">Coderhouse</h3>
              <p>
                UX/UI Design Course in progress
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'transparent', border: '2px solid  #c79292'}}
              date="Mar 2022 - Aug 2022"
              iconStyle={{ background: '#c79292', color: '#fff' }}
              icon={<FaCode />}
            >
              <h3 className="vertical-timeline-element-title">Henry</h3>
              <p>
              Complete Full-Stack Developer career
              </p>

              <Flex wrap='wrap' gap='3' pt={3}>
                <Tag>Javascript</Tag>
                <Tag>Node.js</Tag>
                <Tag>Express</Tag>
                <Tag>React</Tag>
                <Tag>Redux</Tag>
                <Tag>PostgreSQL</Tag>
                <Tag>Sequelize</Tag>
              </Flex>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'transparent', border: '2px solid  #c79292'}}
              date="Jan 2022 - Feb 2022"
              iconStyle={{ background: '#c79292', color: '#fff' }}
              icon={<MdOutlineClass />}
            >
              <h3 className="vertical-timeline-element-title">Coderhouse</h3>
              <p>
              Complete Agile Methodologies course
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'transparent', border: '2px solid  #c79292'}}
              date="Oct 2021 - Dec 2021"
              iconStyle={{ background: '#c79292', color: '#fff' }}
              icon={<FaCode />}
            >
              <h3 className="vertical-timeline-element-title">Coderhouse</h3>
              <p>
                Complete Web Design course
              </p>
              <Flex wrap='wrap' gap='3' pt={3}>
                <Tag>HTML</Tag>
                <Tag>CSS</Tag>
                <Tag>SASS</Tag>
                <Tag>Bootstrap</Tag>
              </Flex>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'transparent', border: '2px solid  #c79292'}}
              date="2019 - Nov 2021"
              iconStyle={{ background: '#c79292', color: '#fff' }}
              icon={<IoSchool />}
            >
              <h3 className="vertical-timeline-element-title">Graduated as a Microbiology and Biotechnology Technician</h3>
            </VerticalTimelineElement>

        </VerticalTimeline>

    </div>
  )
}
